/**
 * frontend customizations in js/jQuery
 *
 * Features:
 * - set ticket amount to 1 by default
 *
 * @package     DeWittePrins\CoreFunctionality;
 * @since       1.4.0
 * @author      Hans Schuijff
 * @link        https://dewitteprins.nl
 * @license     GNU-2.0+
 */
(function ($, document) {
	$(document).ready(function () {
		/**
		 * auto-click the increment quantity button on the ticket block
		 * to set it to one (default zero)
		 *
		 * Changing the default in the ticket template isn't enough
		 * since that doesn't trigger the change event on the quantity field.
		 */
		$('.tribe-tickets__item__quantity__add').trigger('click');
		$('.tribe-tickets__tickets-item-quantity-add').trigger('click');
	});
})(jQuery, document);
